// @ts-nocheck
/* eslint-disable */
export const popoverArrowDownIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 10"><g clip-path="url(#a)"><path fill="currentColor" d="M14.131 9.124a1.956 1.956 0 0 1-3.262 0l-3.845-5.62C5.519 1.306 3.089 0 .5 0h24c-2.59 0-5.02 1.305-6.524 3.505z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M24.5 10H.5V0h24z"/></clipPath></defs></svg>`,
    name: 'popover-arrow-down' as const
};